import { View, useTheme } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';
import './HomePageProject.css';
import { listProjects } from '../graphql/queries';
import { generateClient } from 'aws-amplify/api';
import { useEffect, useState } from 'react';
import ModalView from '../commons/ModalView';
import ViewPageProject from './ViewPageProject';
import CreateAndSeacrh from '../commons/CreateAndSeacrh';
import TableComponent from '../commons/TableComponent';

const client = generateClient();
const LIMIT_PROYECTS_BY_PAGE = 4;

const formStyle = {
    // padding: '50px 20px',
    backgroundColor: '#282c34',
    padding: '1rem',
    width: '30rem',
    height: '28rem',
    color: 'white'
};

function HomePageProject() {
    const [projects, setProjects] = useState([]);
    const [filteredProjects, setFilteredProjects] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [nextToken, setNextToken] = useState(null);
    const [prevTokens, setPrevTokens] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [error, setError] = useState('');
    const [popup, setPopup] = useState(false);
    const [selectProject, setSelectProject] = useState({})
    const navigate = useNavigate();

    const { tokens } = useTheme();

    const handleProjectPageToForm = () => {
        navigate("/admin/project/form");
    };

    const fetchProjects = async (token = null) => {
        try {
            const response = await client.graphql({
                query: listProjects,
                variables: {
                    limit: LIMIT_PROYECTS_BY_PAGE,
                    nextToken: token,
                    SortDirection: 'ASC',
                    sortKey: 'name'
                }
            });
            return response.data.listProjects;
        } catch (e) {
            console.log('Something went wrong', e);
            return null;
        }
    };

    const fetchAllProjects = async () => {
        try {
            const response = await client.graphql({ query: listProjects });
            return response.data.listProjects.items;
        } catch (e) {
            console.log('Something went wrong', e);
            return [];
        }
    };

    useEffect(() => {
        const initializeProjects = async () => {
            const allProjects = await fetchAllProjects();
            setProjects(allProjects);
            const totalPagesCalculated = Math.ceil(allProjects.length / LIMIT_PROYECTS_BY_PAGE);
            setTotalPages(totalPagesCalculated);

            // Fetch the first page of projects
            const result = await fetchProjects();
            if (result && result.items) {
                setFilteredProjects(result.items);
                setNextToken(result.nextToken);
            }
        };

        initializeProjects();
    }, []);

    useEffect(() => {
        const fetchProjectsForPage = async () => {
            const result = await fetchProjects(nextToken);
            if (result && result.items) {
                setFilteredProjects(result.items);
                setNextToken(result.nextToken);
            }
        };

        fetchProjectsForPage();
    }, [currentPage]);

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setPrevTokens([...prevTokens, nextToken]);
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            const newPrevTokens = prevTokens.slice(0, -1);
            setNextToken(newPrevTokens[newPrevTokens.length - 1] || null);
            setPrevTokens(newPrevTokens);
            setCurrentPage(currentPage - 1);
        }
    };

    const handleSearch = (event) => {
        const searchTerm = event.target.value.toLowerCase();
        setSearchTerm(searchTerm);

        if (searchTerm === '') {
            handleClearSearch();
            return;
        }

        const filtered = projects.filter(project => project.name.toLowerCase().includes(searchTerm));
        if (filtered.length > 0) {
            setFilteredProjects(filtered);
            setError('');
        } else {
            setFilteredProjects([]);
            setError('No se encontró ningún proyecto con ese nombre.');
        }
    };

    const handleClearSearch = async () => {
        setSearchTerm('');
        const result = await fetchProjects(prevTokens[currentPage - 1]);
        if (result && result.items) {
            setFilteredProjects(result.items);
            setNextToken(result.nextToken);
        }
        setError('');
    };

    const handlerClickOnObject = async (projectId) => {
        setPopup(true);
        const selectProjectData = projects.filter((project) => project.id === projectId)[0]
        setSelectProject(selectProjectData);
    };

    const closePopup = async () => {
        reloadProjects();
        setPopup(false);
    };
    
    const reloadProjects = async () => {
        const allProjects = await fetchAllProjects();
        setProjects(allProjects);
        const totalPagesCalculated = Math.ceil(allProjects.length / LIMIT_PROYECTS_BY_PAGE);
        setTotalPages(totalPagesCalculated);
    
        // Fetch the first page of projects
        const tokenForCurrentPage = prevTokens[currentPage - 2] || null;
        const result = await fetchProjects(tokenForCurrentPage);
        if (result && result.items) {
            setFilteredProjects(result.items);
            setNextToken(result.nextToken);
        }
    };

    return (
        <div className="container">
            <CreateAndSeacrh 
                tokens={tokens}
                handleObjectPageToForm={handleProjectPageToForm}
                searchTerm={searchTerm}
                handleSearch={handleSearch}
                handleClearSearch={handleClearSearch}
                valuePage={"Crear un proyecto"}
            />
            <TableComponent 
                error={error}
                value={'Nombre'}
                objects={filteredProjects}
                handlerClickOnObject={handlerClickOnObject}
                currentPage={currentPage}
                totalPages={totalPages}
                handleNextPage={handleNextPage}
                handlePreviousPage={handlePreviousPage}
                nameObject={'name'}
            />

            <ModalView isOpen={popup} onClose={closePopup} type='modal-content-view'>
            <View style={formStyle} font="font.inverse">
                            <ViewPageProject
                                selectProject={selectProject}
                                onCancel={closePopup}
                            />
                            </View>
            </ModalView>
        </div>
    );
}

export default HomePageProject;
